/** @format */

import axios from "axios";
import React from "react";
import { useState } from "react";
import Avatar from "@mui/material/Avatar";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { toast } from 'react-toastify';
import SendIcon from "@mui/icons-material/Send";
import LoadingButton from "@mui/lab/LoadingButton";

function AddCustomer() {
  const [loading, setLoading] = useState(false);
  async function addCustomer(cname, cadd, cdesc) {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/v1/customer?name=${cname}&address=${cadd}&description=${cdesc}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(
              localStorage.getItem("accessToken")
            )}`,
          },
        }
      );
      console.log(response.data)
      setLoading(false);
      toast.success('Customer successfully added!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        });
    } catch (err) {
      setLoading(false)
      toast.error(`${err.message}`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        });
      console.log(err);
    }
  }
  const handleSubmit = async (event) => {
    setLoading(true);
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    addCustomer(
      data.get("customer-name"),
      data.get("customer-address"),
      data.get("customer-description")
    );
    event.target.reset();
  };
  return (
    <>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}>
          <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
            <HowToRegIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Add Customer
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit}
            method="POST"
            sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="customer-name"
              label="Customer Name"
              name="customer-name"
              defaultValue=""
            />
            <TextField
              margin="normal"
              required
              fullWidth
              id="customer-address"
              label="Customer Address"
              name="customer-address"
              defaultValue=""
            />
            <TextField
              margin="normal"
              required
              fullWidth
              id="customer-description"
              label="Customer Description"
              name="customer-description"
              defaultValue=""
            />
            <LoadingButton
              type="submit"
              fullWidth
              loading={loading}
              endIcon={<SendIcon />}
              loadingPosition="end"
              variant="contained"
              sx={{ mt: 3, mb: 2, bgcolor: "secondary.main" }}>
              Add Customer
            </LoadingButton>
          </Box>
        </Box>
      </Container>
    </>
  );
}

export default AddCustomer;
